import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetTradeNameActivities(id: string | undefined) {
  return useQuery(queries.products.getTradeNameActivitiesById(id || ''))
}
